import React, { useEffect, useState } from 'react';
import { adminAPI } from '../../../services/api';

const fmtCurrency = (n) => `₺${Number(n || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const fmtInt = (n) => Number(n || 0).toLocaleString('tr-TR');

const StatCard = ({ label, value, hint }) => (
  <div className="admin-stat-card">
    <div className="admin-stat-label">{label}</div>
    <div className="admin-stat-value">{value}</div>
    {hint && <div className="admin-stat-hint">{hint}</div>}
  </div>
);

const AdminStatsTab = () => {
  const [stats, setStats] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    adminAPI.getStats()
      .then((res) => { if (active) setStats(res.data); })
      .catch((e) => { if (active) setError(e.message); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);

  if (loading) return <div className="admin-empty">Loading…</div>;
  if (error) return <div className="admin-error">{error}</div>;
  if (!stats) return null;

  const { users, orders, usersByPlan, revenueByPlan, signupsLast30Days, revenueLast30Days } = stats;

  return (
    <div className="admin-stats">
      <h2>Overview</h2>
      <div className="admin-stat-grid">
        <StatCard label="Total users" value={fmtInt(users.total_users)} />
        <StatCard label="Active users" value={fmtInt(users.active_users)} />
        <StatCard label="Admins" value={fmtInt(users.admin_users)} />
        <StatCard label="New users (7d)" value={fmtInt(users.new_users_7d)} />
        <StatCard label="New users (30d)" value={fmtInt(users.new_users_30d)} />
        <StatCard label="Successful orders" value={fmtInt(orders.successful_orders)} hint={`${fmtInt(orders.failed_orders)} failed`} />
        <StatCard label="Total revenue" value={fmtCurrency(orders.total_revenue)} hint={`${fmtInt(orders.total_orders)} total orders`} />
      </div>

      <h2>Users by plan</h2>
      <div className="admin-table-wrap">
        <table className="admin-table">
          <thead><tr><th>Plan</th><th>Users</th></tr></thead>
          <tbody>
            {usersByPlan.map((row) => (
              <tr key={row.id}><td>{row.name}</td><td>{fmtInt(row.user_count)}</td></tr>
            ))}
          </tbody>
        </table>
      </div>

      <h2>Revenue by plan</h2>
      <div className="admin-table-wrap">
        <table className="admin-table">
          <thead><tr><th>Plan</th><th>Orders</th><th>Revenue</th></tr></thead>
          <tbody>
            {revenueByPlan.map((row) => (
              <tr key={row.id}>
                <td>{row.name}</td>
                <td>{fmtInt(row.order_count)}</td>
                <td>{fmtCurrency(row.revenue)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <h2>Signups (last 30 days)</h2>
      {signupsLast30Days.length === 0 ? (
        <div className="admin-empty">No signups in the last 30 days.</div>
      ) : (
        <div className="admin-table-wrap">
          <table className="admin-table">
            <thead><tr><th>Day</th><th>Signups</th></tr></thead>
            <tbody>
              {signupsLast30Days.map((row) => (
                <tr key={row.day}><td>{row.day}</td><td>{fmtInt(row.signups)}</td></tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <h2>Revenue (last 30 days)</h2>
      {revenueLast30Days.length === 0 ? (
        <div className="admin-empty">No successful orders in the last 30 days.</div>
      ) : (
        <div className="admin-table-wrap">
          <table className="admin-table">
            <thead><tr><th>Day</th><th>Orders</th><th>Revenue</th></tr></thead>
            <tbody>
              {revenueLast30Days.map((row) => (
                <tr key={row.day}>
                  <td>{row.day}</td>
                  <td>{fmtInt(row.orders)}</td>
                  <td>{fmtCurrency(row.revenue)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AdminStatsTab;
